import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { formatDateSlash } from 'utils/dateHelpers';
import { ZCOR_START } from '../../reducer';

// Se muestra al calcular un producto que ya tiene versiones ZCOR guardadas. Una versión se
// puede seguir editando hasta que una cotización emitida la usa; desde ahí solo se puede
// partir de ella para crear una nueva.
const ZcorVersionChoiceDialog = function (props) {
  const { open, version, onChoose } = props;
  if (!version) return null;

  const { versionLabel, versionDate, userName, locked } = version;
  return (
    <Dialog fullWidth maxWidth="sm" open={open}>
      <DialogTitle>Este producto tiene versiones ZCOR guardadas</DialogTitle>
      <DialogContent>
        <Typography mb="10px">
          {`Última versión: ${versionLabel} del ${formatDateSlash(versionDate)}${
            userName ? `, guardada por ${userName}` : ''
          }.`}
        </Typography>
        <Typography>
          {locked
            ? 'Esta versión ya se usó en una cotización emitida, así que no se puede modificar. Puede crear una versión nueva a partir de sus valores o partir desde el ZCOT vigente.'
            : 'Puede seguir editando esta versión (los cambios se guardan sobre ella) o partir desde el ZCOT vigente, lo que crea una versión nueva al guardar.'}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onChoose(ZCOR_START.BLANK)}>Fórmula en blanco (ZCOT vigente)</Button>
        {locked ? (
          <Button variant="contained" onClick={() => onChoose(ZCOR_START.COPY)}>
            Nueva versión a partir de esta
          </Button>
        ) : (
          <Button variant="contained" onClick={() => onChoose(ZCOR_START.EDIT)}>
            {`Editar versión ${versionLabel}`}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default ZcorVersionChoiceDialog;
